module.exports = __webpack_public_path__ + "static/img/xsms.b76893e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xsms.png
// module id = /DrO
// module chunks = 1